import { render } from "./ManagerUserTerms.vue?vue&type=template&id=fe74f524"
import script from "./ManagerUserTerms.vue?vue&type=script&lang=js"
export * from "./ManagerUserTerms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__